import React, { useMemo } from 'react';
import './Navigation.css';

const NAVLINKS = {
  about: {
    name: 'About',
    path: '/about',
  },
  portfolio: {
    name: 'Portfolio',
    path: '/portfolio',
  },
  cv: {
    name: 'CV',
    path: '/cv',
  },
};

const PAGES = ['about', 'portfolio', 'cv'];

export default function Navigation() {
  const navmap = PAGES.map((page) => NAVLINKS[page]);

  const navlinks = useMemo(() => {
    const links = [];
    for (let i = 0; i < 3; i++) {
      const entry = navmap[i];
      links.push(
        <a className="navlink" key={i} href={entry.path}>
          {entry.name}
        </a>,
      );
    }
    return links;
  }, [navmap]);

  return <div className="nav-links-container">{navlinks}</div>;
}
